import React from 'react'

import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'

const ExamApplicationNotificationItem = ({ name, createdAt }) => (
  <>
    <TableRow>
      <TableCell component="th" scope="row">
        {name}
      </TableCell>
      <TableCell align="right">{createdAt}</TableCell>
    </TableRow>
  </>
)

export default ExamApplicationNotificationItem
